export default {
  development: 'http://localhost:3000',
  production: 'https://alpha.qmkey.com/backend',
};
